<script>
import RecycleModal from './RecycleModal.vue'
import Accordion from '../../Accordion.vue'
import AccordionItem from '../../AccordionItem.vue'
import LoadingCvPersonalDetails from '../Applicant/LoadingCV/PersonalDetails.vue'
import LoadingCvAims from '../Applicant/LoadingCV/Aims.vue'
import StarRating from 'vue-star-rating'
import FailModal from './FailModal.vue'
import Cv from './LoadingCV/Cv.vue'
import moment from 'moment'
import ComponentStarRating from '../../ComponentStarRating.vue'
import BackgroundVerificationCheckModal from './BackgroundVerificationCheckModal.vue'
import PassModal from './PassModal.vue'

export default {
    components: {
        RecycleModal,
        Accordion,
        AccordionItem,
        LoadingCvPersonalDetails,
        LoadingCvAims,
        StarRating,
        FailModal,
        Cv,
        ComponentStarRating,
        BackgroundVerificationCheckModal,
        PassModal
    },
    props: {
        jobApplication: {
            type: Object|Array,
            required: true
        },
        csrfToken: {
            type: String,
            required: true
        },
        module: {
            type: Object|Array,
            required: true
        },
        traitStatementsByCluster: {
            type: Object|Array,
            required: true
        },
        interviewAnswers: {
            type: Object|Array,
            required: true
        },
        interviewScores: {
            type: Object|Array,
            required: true
        },
        logs: {
            type: Object|Array,
            required: false
        },

    },
    data() {
        return {
            average: 0,
            rating: [],
            fail_reason: '',
            passBtnDisabled: false,
            first_interview_status: this.jobApplication.first_interview_status,
            inviteBtnDisabled: false
        }
    },

    methods: {
        toggleModal(ref) {
            this.$refs[ref].toggleModal()
        },
        sliceString(value) {
            return value.substring(value.lastIndexOf("/") + 1)
        },
        changeRatingValue(key, value) {
            this.rating[key] = parseInt(value);
        },
        fail(fail_reason) {
            this.fail_reason = fail_reason
            this.$nextTick(() => {
                this.$refs.failedButton.click();
            });
        },
        convertDate(date, format = 'YYYY-MM-DDThh:mm') {
            return moment.parseZone(date).format(format)
        },
        setRating: function(rating){
            this.rating = parseInt(rating);
        },
        disablePassBtn() {
            this.passBtnDisabled = true;
            this.first_interview_status = 'passed';
        },
        disableInviteBtn() {
            this.inviteBtnDisabled = true;
        },
        backgroundCheck(value) {
            this.is_background_check_manual = value.manual_pass;
        },
        modalMessage() {
            if (
                this.iFactsMatricCheck &&
                !this.matricCertNumber &&
                this.jobApplication.background_verification_results.length <= 0
            ) {
                return 'This person you are trying to send to iFacts does not have a Matric Certificate to check.\nAre you sure you want to send all remaining checks?'
            }

            return 'Are you sure? Passing the candidate will fire off iFacts API checks'
        },
        pass(value) {
            this.first_interview_status = 'passed';

            this.$nextTick(() => {
                this.$refs.passedButton.click();
            });
        },
    },

    mounted() {
        if (this.jobApplication.showBackgroundVerificationWarning) {
            this.toggleModal('backgroundVerificationCheckModal')
        }

        if (this.jobApplication.first_interview_status == 'passed') {
            this.passBtnDisabled = true;
        }
    },
    watch: {
        //watch jobApplication deep true
        jobApplication: {
            handler: function (newVal, oldVal) {
                this.passBtnDisabled = false;
                if (newVal.first_interview_status == 'passed') {
                    this.passBtnDisabled = true;
                }
            },
            deep: true
        }
    },
    computed: {
        disabled() {
            return ( this.jobApplication.telephonic_screening_status === null || this.jobApplication.telephonic_screening_status === '') ? true : false
        },
        excludedIds() {
            if (
                this.iFactsMatricCheck &&
                !this.matricCertNumber &&
                this.jobApplication.background_verification_results.length <= 0
            ) {
                return this.iFactsMatricCheck.map(function (item) {
                    return item.id;
                }).join(',')
            }

            if (
                this.iFactsMatricCheck &&
                this.matricCertNumber &&
                (
                    this.jobApplication.background_verification_results.length !==
                    this.jobApplication.job.requisition.person_specification.background_verification_specs.length
                )
            ) {
                return this.jobApplication.background_verification_results.map(function (item) {
                    return item.background_verification_spec_id
                })
                    .join(',')
            }
        },
        iFactsMatricCheck() {
            if (!this.jobApplication.job.requisition.person_specification.background_verification_specs) {
                return null;
            }

            return this.jobApplication.job.requisition.person_specification.background_verification_specs.filter(function (data) {
                if (!data.ifacts_check) {
                    return null;
                }
                return [55, 56, 57, 132, 6, 7, 98].includes(parseInt(data.ifacts_check.check_id));
            });
        },
        matricCertNumber() {
            if (this.jobApplication.user.user_detail === null) {
                return null;
            }

            const qualification = this.jobApplication.user.user_detail.qualifications.find(function (data) {
                return data.highest_edu_level == 1;
            });

            if (qualification) {
                return qualification.qualification_documents.length > 0;
            }

            return null
        },
    }
}
</script>

<template>
    <div class="first-interview">
        <div class="grid-x grid-padding-x">
            <div class="cell small-6" style="border-right: solid 1px #D1D1D1; padding: 30px 35px">
                <div style="width:90%">
                    <strong>Invite candidate to a first interview:</strong>
                    <p>Pick three timeslots that the candidate will be able to pick from</p>
                    <br>

                    <form action="" method="post" class="pt-0" v-on:submit="disableInviteBtn">
                        <input type="hidden" name="_csrfToken" :value="csrfToken" />
                        <div class="form-control px-0">
                            <label>Option 1</label>
                            <input
                                :disabled="disabled"
                                type="datetime-local"
                                name="first_interview_result[date_first]"
                                required
                                :value="(jobApplication.first_interview_result) ? convertDate(jobApplication.first_interview_result.date_first) : convertDate(this.value)"
                            />
                        </div>

                        <div class="form-control px-0">
                            <label>Option 2</label>
                            <input
                                :disabled="disabled"
                                type="datetime-local"
                                name="first_interview_result[date_second]"
                                required
                                :value="(jobApplication.first_interview_result) ? convertDate(jobApplication.first_interview_result.date_second) : convertDate(this.value)"
                            />
                        </div>

                        <div class="form-control px-0">
                            <label>Option 3</label>
                            <input
                                :disabled="disabled"
                                type="datetime-local"
                                name="first_interview_result[date_third]"
                                required
                                :value="(jobApplication.first_interview_result) ? convertDate(jobApplication.first_interview_result.date_third) : convertDate(this.value)"
                            />
                        </div>
                        <button :disabled="disabled" class="button mt-2" name="first_interview_invitation" type="submit">Send Invite</button>
                    </form>
                    <form action="" method="post" class="pt-0 mt-2">
                        <input type="hidden" name="_csrfToken" :value="csrfToken" />
                        <div class="form-control px-0">
                            <label>Set date and time manually</label>
                            <input
                                :disabled="disabled"
                                type="datetime-local"
                                name="first_interview_result[date_first]"
                                required 
                                :value="(jobApplication.first_interview_result) ? convertDate(jobApplication.first_interview_result.date_first) : convertDate(this.value)"
                            />
                        </div>
                        <button :disabled="disabled" class="button mt-2" name="first_interview_invitation_manually" type="submit">Set time manually</button>
                    </form>
                    <br />
                    <Cv
                        :jobApplication="jobApplication"
                        :module="module"
                        :trait-statements-by-cluster="traitStatementsByCluster"
                    />
                </div>
            </div>
            <div class="cell small-6 p-4">
                <form action="" method="post" class="pt-0 mt-2" v-on:submit="disablePassBtn">
                    <input type="hidden" name="exclude_matric_check" :value="excludedIds"/>
                    <input type="hidden" name="_csrfToken" :value="csrfToken" />
                    <input type="hidden" name="fail_reason" :value="fail_reason" />
                    <input type="hidden" name="first_interview_status" :value="first_interview_status" />

                    <h4>Invitation</h4>
                    <div v-if="jobApplication.first_interview_result">
                        <strong>Invitation Status:</strong> {{ (jobApplication.first_interview_result.status === 'reschedule') ? 'The candidate is not available.  Please resend a new invitation.' : jobApplication.first_interview_result.status }}
                        <br>
                        <strong>Date and Time Scheduled:</strong>{{ jobApplication.first_interview_result.date_selected ? convertDate(jobApplication.first_interview_result.date_selected, 'MMMM D, YYYY H:mm') : '' }}
                        <br>
                    </div>
                    <div v-else>
                        <strong>Invitation Status:</strong> Not yet sent
                        <br>
                        <strong>Date and Time Scheduled:</strong> Not yet set
                        <br>
                    </div>
                    <strong>Final Status:</strong> {{ jobApplication.first_interview_status }}
                    <span v-if="logs !== null && logs !== ''">
                        &nbsp;(Updated By {{ logs.user.first_name }} {{ logs.user.last_name }} - {{ convertDate(logs.created, 'YYYY-MM-DD HH:mm') }})
                    </span>
                    <div class="grid-x grid-padding-x mt-3">
                        <div class="cell shrink">
                            <div v-if="this.jobApplication.job.requisition.person_specification.ats_type != 'agent'">
                                <button class="d-none" ref="passedButton"></button>
                                <button class="button success px-5" type="button" @click="toggleModal(jobApplication.ifact_form ? 'passModal' : 'backgroundVerificationCheckModal')" :disabled="passBtnDisabled || disabled">
                                    Pass
                                </button>
                            </div>
                            <div v-else>
                                <button class="button px-5" type="submit" :disabled="passBtnDisabled || disabled">Pass</button>
                            </div>
                        </div>
                        <div class="cell shrink">
                            <button :disabled="disabled" class="d-none" value="failed" ref="failedButton"
                                name="first_interview_status"></button>
                            <button :disabled="disabled" class="button alert px-5" type="button" @click="toggleModal('failModal')">Fail</button>
                        </div>
                        <div class="cell shrink">
                            <button :disabled="disabled" class="button recycle px-5" type="button"
                                @click="toggleModal('recycleModal')">Recycle</button>
                        </div>
                    </div>
                    <hr>
                    <h4 class="mt-4">Interview Questions</h4>

                    <div v-for="(interviewQuestion, index) in jobApplication.job.requisition.person_specification.interview_questions" :key="`interview_question_${index}`">
                        <div v-if="interviewQuestion.phase == 'First Interview'">
                            <!-- <input type="hidden" :name="`language_proficiency_scores[${i}][id]`" :value="langProf.id" /> -->
                            <input
                                type="hidden"
                                :name="`interview_answers[${index}][job_application_id]`"
                                :value="jobApplication.id"
                            />
                            <input
                                type="hidden"
                                :name="`interview_answers[${index}][interview_question_id]`"
                                :value="interviewQuestion.id"
                            />

                            <div v-if="interviewAnswers[interviewQuestion.id]">
                                <input
                                    type="hidden"
                                    :name="`interview_answers[${index}][id]`"
                                    :value="interviewAnswers[interviewQuestion.id]['id']"
                                />
                            </div>

                            <div class="d-flex align-items-center gap-1">
                                <p><strong>{{ index + 1 }}. </strong></p> <span v-html="interviewQuestion.title"></span>
                            </div>

                            <div class="d-flex" v-if="interviewQuestion.answer_type == 'yes_no'">
                                <div class="d-flex align-items-center yes-no-item">
                                    <input
                                        :disabled="disabled"
                                        type="radio"
                                        value="1"
                                        :name="`interview_answers[${index}][answer]`"
                                        :checked="(interviewAnswers[interviewQuestion.id] && interviewAnswers[interviewQuestion.id]['answer'] == 1)"
                                    />
                                    <label>Yes</label>
                                </div>

                                <div class="d-flex align-items-center yes-no-item">
                                    <input
                                        :disabled="disabled"
                                        type="radio"
                                        value="0"
                                        :name="`interview_answers[${index}][answer]`"
                                        :checked="(interviewAnswers[interviewQuestion.id] && interviewAnswers[interviewQuestion.id]['answer'] == 0)"
                                    />

                                    <label>No</label>
                                </div>
                            </div>

                            <div v-if="interviewQuestion.answer_type == 'free'">
                                <textarea v-if="interviewAnswers[interviewQuestion.id]" rows="40" :disabled="disabled" :name="`interview_answers[${index}][answer]`" v-model="interviewAnswers[interviewQuestion.id]['answer']"></textarea>
                                <textarea v-else rows="40" :disabled="disabled" :name="`interview_answers[${index}][answer]`"></textarea>
                            </div> 

                            <div v-if="interviewQuestion.answer_type == 'rating'">
                                <component-star-rating
                                    :disabled="disabled"
                                    :name="`interview_answers[${index}][answer]`"
                                    :star-size="18"
                                    border-color="#455666"
                                    active-border-color="#455666"
                                    :border-width="3"
                                    rounded-corners
                                    :padding="1"
                                    inactive-color="white"
                                    :default-rating="parseInt(interviewAnswers[interviewQuestion.id] ? interviewAnswers[interviewQuestion.id]['answer'] : 0)"
                                ></component-star-rating>
                            </div>
                            <br>
                        </div>
                    </div>

                    <input
                        type="hidden"
                        name="interview_scores[0][job_application_id]`"
                        :value="jobApplication.id"
                    />

                    <input type="hidden" name="interview_scores[0][phase]`" value="First Interview" />
                    
                    <input
                        type="hidden"
                        name="interview_scores[0][id]`"
                        :value="interviewScores['First Interview'] ? interviewScores['First Interview']['id'] : null"
                    />
                    
                    <div class="form-control">
                        <label>Pitch:</label>
                        <input
                            :disabled="disabled"
                            type="number"
                            step="1"
                            min="0"
                            max="4"
                            required
                            name="interview_scores[0][pitch]"
                            :value="interviewScores['First Interview'] ? interviewScores['First Interview']['pitch'] : 0"
                        />
                    </div>

                    <br>
                    <div class="form-control">
                        <label>Pace:</label>

                        <input
                            :disabled="disabled"
                            type="number"
                            step="1"
                            min="0"
                            max="4"
                            required
                            name="interview_scores[0][pace]"
                            :value="interviewScores['First Interview'] ? interviewScores['First Interview']['pace'] : 0"
                        />
                    </div>

                    <br>
                    <div class="form-control">
                        <label>Tone:</label>

                        <input
                            :disabled="disabled"
                            type="number"
                            step="1"
                            min="0"
                            max="4"
                            required
                            name="interview_scores[0][tone]"
                            :value="interviewScores['First Interview'] ? interviewScores['First Interview']['tone'] : 0"
                        />
                    </div>

                    <br>
                    <div class="form-control">
                        <label>Clarity:</label>

                        <input
                            :disabled="disabled"
                            type="number"
                            step="1"
                            min="0"
                            max="4"
                            required
                            name="interview_scores[0][clarity]"
                            :value="interviewScores['First Interview']? interviewScores['First Interview']['clarity'] : 0"
                        />
                    </div>

                    <br>
                    <div class="form-control">
                        <label>Score:</label>

                        <input
                            :disabled="disabled"
                            type="number"
                            step="1"
                            min="0"
                            max="4"
                            required
                            name="interview_scores[0][score]"
                            :value="interviewScores['First Interview'] ? interviewScores['First Interview']['score'] : 0"
                        />
                    </div>

                    <div class="form-control">
                        <div class="grid-x grid-padding-x">
                            <div class="cell shrink">
                                <div v-if="this.jobApplication.job.requisition.person_specification.ats_type != 'agent'">
                                    <button class="d-none" ref="passedButton"></button>
                                    <button class="button success px-5" type="button" @click="toggleModal(jobApplication.ifact_form ? 'passModal' : 'backgroundVerificationCheckModal')" :disabled="passBtnDisabled || disabled">
                                        Pass
                                    </button>
                                </div>
                                <div v-else>
                                    <button class="button px-5" type="submit" :disabled="passBtnDisabled || disabled">Pass</button>
                                </div>
                            </div>
                            <div class="cell shrink">
                                <button class="d-none" value="failed" ref="failedButton"
                                    name="first_interview_status"></button>
                                <button :disabled="disabled" class="button alert px-5" type="button" @click="toggleModal('failModal')">Fail</button>
                            </div>
                            <div class="cell shrink">
                                <button :disabled="disabled" class="button recycle px-5" type="button"
                                    @click="toggleModal('recycleModal')">Recycle</button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>

        <recycle-modal
            ref="recycleModal"
            :job-application="jobApplication" :csrf-token="csrfToken"
        />
        <fail-modal
            ref="failModal"
            :job-application="jobApplication" @submit="fail"
        />

        <background-verification-check-modal ref="backgroundVerificationCheckModal" :job-application="jobApplication" :csrf-token="csrfToken" />
        <pass-modal ref="passModal" :job-application="jobApplication" @submit="pass" @backgroundCheck="backgroundCheck" :message="modalMessage()"/>
    </div>
</template>